import { Box, Autocomplete, TextField, InputAdornment } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

const SearchBar = ({ pagesList, handleSearch }) => (
  <Box className='pagesListSearchContainer'>
    <Autocomplete
      className='pagesListSearch'
      freeSolo
      onChange={handleSearch}
      options={pagesList}
      getOptionLabel={(page) => page?.label || page.url || ''}
      getOptionKey={page => page.id}
      filterOptions={(options, { inputValue }) =>
        options.filter(
          (option) =>
            option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.url.toLowerCase().includes(inputValue.toLowerCase())
        )
      }
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          className='pagesListSearchInput'
          variant="standard"
          placeholder='Search...'
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  </Box>
)

export default SearchBar